function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "#FF8A00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 21.667l.774-10.836a.776.776 0 10-1.548 0L20 21.667z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.774 10.831l1.995.143-1.995-.143zM20 21.667l-1.995.142a2 2 0 003.99 0L20 21.667zm-.774-10.836l1.995-.142-1.995.142zm-.447-.142l-.774 10.835 3.99.285.774-10.835-3.99-.285zm3.216 10.835L21.22 10.69l-3.99.285.774 10.835 3.99-.285zM21.22 10.69c.05.708-.51 1.311-1.221 1.311V8a2.776 2.776 0 00-2.769 2.974l3.99-.285zm1.548.285A2.776 2.776 0 0020 8v4c-.71 0-1.272-.603-1.221-1.311l3.99.285z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 28.333V30",
  stroke: "#fff",
  strokeWidth: "4",
  strokeLinecap: "round"
})));